import { SxProps } from '@mui/system';

export const CopyAllIconStyle: SxProps = {
    display: 'flex',
    position: 'absolute',
    right: 0,
    bottom: 0,
    zIndex: 10,
};
